
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandN as ObiOwnShipNoCommandNElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-n.js';
 
 
 

 
 export const ObiOwnShipNoCommandN = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-n',
   elementClass: ObiOwnShipNoCommandNElement,
   events: {
     
   }
  });
 
 